export default __webpack_public_path__ + "static/media/RobotoSlab-Bold.a53f435c.ttf";